
import React from 'react';
import isString from 'lodash/isString';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import Lightbox from 'react-image-lightbox';

import getStylesFromCssString from './getStylesFromCssString';
import getStylesFromDefinition from './getStylesFromDefinition';
import processTemplateValues from './processTemplateValues';

import 'react-image-lightbox/style.css';

if (typeof global === 'undefined') {
  window.global = window;
}

const classNames = mergeStyleSets({
    img: {
        cursor: 'pointer'
    },
    imgBox: {
    },
    imgContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, max-content)',
        gap: '1em'
    },
});

const Image = ({
    className,
    imgUrl,
    title,
    imageIndex,
    onClick
}) => {

    const handleClick = () => {
        if (onClick) {
            onClick(imageIndex);
        }
    }

    return (
        <div className={classNames.imgBox}>
            <div onClick={handleClick} >
                <img
                    className={className}
                    src={`${imgUrl}`}
                    alt={title}
                    title={title}
                />
            </div>
        </div>

    );
};

const Images = ({
    definition,
    items,
    values,
    onLightboxOpenChange
}) => {

    const [lightbox, setLightbox] = React.useState({isOpen: false, index: 0});

    const getImageProps = (item) => {
        const title = isString(item) ? item : item.title || '';
        const image = isString(item) ? item : item.image;
        const urlFull = processTemplateValues(definition.urlFull, values) + image;
        const urlPreview = processTemplateValues(definition.urlPreview, values) + image;
        return {
            image,
            title,
            urlFull,
            urlPreview
        };
    }

    const getSources = () => {
        return items.map(item => {
            const imgProps = getImageProps(item);
            return imgProps;
        });
    }

    const images = getSources();

    const handleImageClick = (imageIndex) => {
        setLightbox({
            isOpen: true,
            index: imageIndex
        });
        if (onLightboxOpenChange) {
            onLightboxOpenChange(true);
        }
    }

    const handleImageClose = () => {
        setLightbox({isOpen: false});
        if (onLightboxOpenChange) {
            onLightboxOpenChange(false);
        }
    }

    const handleMoveNext = () => {
        setLightbox({
            index: (lightbox.index + 1) % images.length,
            isOpen: true
        });
    }

    const handleMovePrev = () => {
        setLightbox({
            index: (lightbox.index + images.length - 1) % images.length,
            isOpen: true
        });
    }

    return (
        <>
            <div className={classNames.imgContainer}>
                {items.map((item, index) => {
                    const imgProps = getImageProps(item);
                    return (
                        <Image
                            key={imgProps.image}
                            className={classNames.img}
                            imgUrl={imgProps.urlPreview}
                            title={imgProps.title}
                            imageIndex={index}
                            onClick={handleImageClick}
                        />
                    )
                })}
            </div>
            {lightbox.isOpen &&
                <Lightbox
                    mainSrc={images[lightbox.index].urlFull}
                    nextSrc={images[(lightbox.index + 1) % images.length].urlFull}
                    prevSrc={images[(lightbox.index + images.length - 1) % images.length].urlFull}
                    imageCaption={images[lightbox.index].title}
                    enableZoom={false}
                    reactModalStyle={{
                        overlay: {
                            zIndex: 2000000
                        }
                    }}
                    nextLabel="Další obrázek"
                    prevLabel="Předchozí obrázek"
                    closeLabel="Zavřít"
                    onCloseRequest={handleImageClose}
                    onMovePrevRequest={handleMovePrev}
                    onMoveNextRequest={handleMoveNext}
                />
            }
        </>
    );
}

const AttributeImages = ({appConfig, definition, infoDefinition, values, onLightboxOpenChange}) => {

    const classNames = mergeStyleSets({
        root: {
            paddingTop: 4,
            paddingBottom: 4,
            ...getStylesFromDefinition(appConfig, 'info.styles.attrContainer'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrContainer'),
            ...getStylesFromCssString(definition.containerStyles)
        },
        title: {
            ...getStylesFromDefinition(appConfig, 'info.styles.attrTitle'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrTitle'),
            ...getStylesFromCssString(infoDefinition.containerStyles),
        },
    });

    let content = null;
    let images = values[definition.name];
    if (images) {
        if (isString(images)) {
            try {
                images = JSON.parse(images);
            }
            catch (e) {
                images = null;
            }
        }
        if (images && images.images) {
            content = (
                <Images
                    definition={definition}
                    items={images.images }
                    values={values}
                    onLightboxOpenChange={onLightboxOpenChange}
                />
            );
        }
    }

    return (content &&
        <Stack className={classNames.root}>
            <Stack.Item className={classNames.title}>
                {definition.title
                    ? <div>{definition.title} :</div>
                    : null
                }
            </Stack.Item>
            <Stack.Item>
                {content}
            </Stack.Item>
        </Stack>
    );
}

export default AttributeImages;
